import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { CardBlockTitleComponent } from '../card-block-title/card-block-title.component';

@Component({
    selector: 'vw-card-block',
    imports: [CardBlockTitleComponent],
    templateUrl: './card-block.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './card-block.component.scss'
})
export class CardBlockComponent {
  @Input() title?: string;
}
